import type { SVGProps } from "react";
import * as React from "react";

const SvgChevronsRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.293 16.293a1 1 0 0 0 1.414 1.414zM18 12l.707.707a1 1 0 0 0 0-1.414zm-4.293-5.707a1 1 0 1 0-1.414 1.414zm-8.414 10a1 1 0 1 0 1.414 1.414zM11 12l.707.707a1 1 0 0 0 0-1.414zM6.707 6.293a1 1 0 0 0-1.414 1.414zm7 11.414 5-5-1.414-1.414-5 5zm5-6.414-5-5-1.414 1.414 5 5zm-12 6.414 5-5-1.414-1.414-5 5zm5-6.414-5-5-1.414 1.414 5 5z"
    />
  </svg>
);
export default SvgChevronsRight;
